import { FileWithHandle } from "browser-fs-access";
import { atomWithReset } from "jotai/utils";
import { ParserIssues } from "src/import/inp";

export type OpenInpDialogState = {
  type: "openInp";
  file: FileWithHandle;
};

export type InvalidFilesErrorDialogState = {
  type: "invalidFilesError";
};

export type UnsavedChangesDialogState = {
  type: "unsavedChanges";
  onContinue: () => void;
};

export type FileOperationDialogState = {
  type: "fileOperation";
  defaultTab?: "new" | "local" | "examples";
};  // 添加新的文件操作统一对话框状态类型

export type SimulationSummaryState = {
  type: "simulationSummary";
  status: "success" | "failure" | "warning";
  duration?: number;
  source?: "local" | "cloud"; // 添加“本地仿真或是云端仿真”这个可选属性
};

export type SimulationReportDialogState = {
  type: "simulationReport";
};

export type WelcomeDialogState = {
  type: "welcome";
};

export type GeocodingNotSupportedDialogState = {
  type: "inpGeocodingNotSupported";
};

export type MissingCoordinatesDialogState = {
  type: "inpMissingCoordinates";
  issues: ParserIssues;
};

export type InpIssuesDialogState = {
  type: "inpIssues";
  issues: ParserIssues;
};

export type AlertInpOutputState = {
  type: "alertInpOutput";
  onContinue: () => void;
};

export type UpgradeDialogState = {
  type: "upgrade";
};

export interface WorkspaceState {
  type: "workspace";
};  // 添加新的对话框状态类型

export interface PublicProjectGalleryState {
  type: "publicProjectGallery";
};  // 添加新的对话框状态类型

//  删除接口定义，改为 内联定义
// export interface CreateCloudProjectDialogState {
//   type: "createCloudProject";
//   initialData?: {
//     projectId?: string;
//     projectName?: string;
//     inpContent?: string;
//     compressedInp?: string;
//     originalSize?: number;
//     compressedSize?: number;
//   };
// };  // 添加新的对话框状态类型

export type DialogState =
  | OpenInpDialogState
  | InvalidFilesErrorDialogState
  | {
      type: "cheatsheet";
    }
  | UnsavedChangesDialogState
  | { type: "createNew" }
  // | { type: "workspace" }           // 新增：工作空间对话框
  | { type: "createCloudProject"; isEmbedded?: boolean; updateMapState?: boolean }  // 新增：内联定义的创建云端项目对话框
  | { type: "importInpToProject" }     // 新增：导入INP到项目对话框
  | { type: "fileOperation"; defaultTab?: "new" | "local" | "examples" }
  | WorkspaceState
  | PublicProjectGalleryState
  // | CreateCloudProjectDialogState  //  删除接口定义，改为 内联定义
  | SimulationSummaryState
  | SimulationReportDialogState
  | WelcomeDialogState
  | InpIssuesDialogState
  | { type: "loading" }
  | AlertInpOutputState
  | GeocodingNotSupportedDialogState
  | MissingCoordinatesDialogState
  | UpgradeDialogState
  | { type: "simulationSettings" }
  | null;

export const dialogFromUrl = (): DialogState => {
  if (typeof window === "undefined") return null;

  const params = new URLSearchParams(window.location.search);

  const dialog = params.get("dialog");
  if (!dialog) return null;

  return { type: dialog } as DialogState;
};

export const dialogAtom = atomWithReset<DialogState>(null);
